import { Injectable } from '@angular/core';
import { UUIDService } from '../uuid/uuid.service';
import { StorageService } from '../storage/storage.service';
import { OidcConfiguration } from '../../model/OidcConfiguration';
import * as sjcl from 'sjcl';

@Injectable({
  providedIn: 'root'
})
export class StateService {
  constructor(private storageService: StorageService,
    private uuidService : UUIDService) {}

  public getState() {
    return sessionStorage.getItem(
      this.storageService.getStorageKey(OidcConfiguration.storageStatePostfix)
    );
  }

  public setState(value) {
    sessionStorage.setItem(
      this.storageService.getStorageKey(OidcConfiguration.storageStatePostfix),
      value
    );
  }

  public clearState() {
    sessionStorage.removeItem(
      this.storageService.getStorageKey(OidcConfiguration.storageStatePostfix)
    );
  }

  /**
   * GÃ©nÃ¨re et conserve une valeur pour le paramÃ¨tre `state`, qui sera vÃ©rifiÃ© par la suite
   *
   */
  public makeState() {
    // On rÃ©utilise la valeur actuelle si elle existe (dure le temps d'une sÃ©quence d'autorisation)
    var plainState = this.getState();
    console.log("plainState  "  + plainState) ;
    if (typeof plainState == "undefined" || !plainState) {
      plainState = this.uuidService.uuid();
      // La valeur en clair est conservÃ©e dans le storage
      this.setState(plainState);
    }
    // Un hash est retournÃ© pour la requÃªte OIDC
    return this.hashState(plainState);
  }

  public hashState = function(aState) {
    //return sjcl.a.codec.hex.fromBits(sjcl.a.hash.sha256.hash(aState));
    return sjcl.codec.base64.fromBits(sjcl.hash.sha256.hash(aState));
  };

}

